import React from 'react';

export default function() {
    return (
        <div>
            Loading...
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/views/Places/Loading.js